export class ShipmentARInvoice {
    Id: string | null;
    ShipmentId: string | null;
    StatusCode: string | null;
    StatusName: string | null;
    InvoiceNumber: string | null;
    InvoiceTypeCode: string | null;
    DueDate: Date | null;
    InvoiceDate: Date | null;
    IsAutoCredit: boolean | null;
    IsCancelled: boolean | null;
    InvoiceCurrencyId: string | null;
    InvoiceCurrencyCode: string | null;
    AmountDue: number | null;
    AmountInLocalCurrency: number | null;
    AmountInProfitCurrency: number | null;
    AmountInInvoiceCurrency: number | null;
    IsConstituentInvoice: boolean | null;
    IsConsolidationInvoice: boolean | null;
    ConsolidationInvoiceId: string | null;
    ConsolidationInvoiceNumber: string | null;
}